export class AddOrRemoveTierToUserRequestDTO {
  constructor(
    public typeOperation: string,
    public idUser: number,
    public ctNum: string[],
    public codeJournal?: string,
    public codeJournalOptCaisse?: string,
  ) {
  }
}
export class AddOrRemoveDepotToUserRequestDTO {
  constructor(
    public typeOperation: string,
    public idUser: number,
    public idDepots: string[],
  ) {
  }
}
export class DefinirTierMobileRequestDto {
  constructor(
    public ctNum: string,
    public userName: string,
    public motDePasse: string,
    public email: string,
    public idSite: number
  ) {
  }
}
